/* eslint-disable */
import FuseAnimate from '@/@fuse/core/FuseAnimate';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import CustomDatePicker from '@shared/customComponents/CustomDatePicker/CustomDatePicker';
import { getRoomsfilter } from '@/app/services/CompanyReports/companyReports';
import { getParentsInformation, getSchools } from '@/app/services/reports/reports';
import * as Actions from '@/app/store/actions';
import { generateAgeString } from '@/utils/utils';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import {
	Avatar,
	CircularProgress,
	FormControl,
	IconButton,
	InputAdornment,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TextField,
	Typography,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import './companyReport.css';

export default function ParentReports() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [rows, setRows] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [hasMore, setHasMore] = useState(false);
	const [firstLoad, setFirstLoad] = useState(true);
	const [fetchingMore, setFetchingMore] = useState(false);
	const checkInReportRef = useRef(null);
	const [page, setPage] = useState(1);
	const [filters, setFilters] = useState({
		name: '',
		room_id: '',
		school_id: '',
		package_type: '',
		date_from: '',
		date_to: '',
		export_id: '',
	});

	const [date, setDate] = useState(new Date());
	const [roomPage, setRoomPage] = useState(1);
	const [schools, setSchool] = useState([]);
	const [rooms, setRooms] = useState([]);
	const user = useSelector(({ auth }) => auth.user);
	const [searchQuery, setSearchQuery] = useState('');
	const [isExporting, setIsExporting] = useState(false);
	const [roomId, setRoomid] = useState();

	const handleSearch = (e) => {
		setSearchQuery(e.target.value);
	};

	const handleFilters = (ev) => {
		const { name, value } = ev.target;
		if (name === 'school_id') {
			setFilters({ ...filters, [name]: value, room_id: '' });
			setRooms([]);
			setRoomPage(1);
		} else {
			setFilters({ ...filters, [name]: value });
		}
	};

	useEffect(() => {
		let isMounted = true;
		getSchools().then((res) => {
			if (!isMounted) return;
			setSchool(res?.data?.data);
		});
		return () => {
			isMounted = false;
		};
	}, []);

	useEffect(() => {
		let isMounted = true;
		getRoomsfilter(roomPage, filters?.school_id == 'All' ? '' : filters?.school_id)
			.then((res) => {
				if (!isMounted) return;
				setRooms([...rooms, ...res.data.data]);
				if (res.data.current_page < res.data.last_page) {
					setRoomPage(roomPage + 1);
				}
			})
			.catch((err) => {
				if (!isMounted) return;
				dispatch(
					Actions.showMessage({
						message: 'Failed to get rooms.',
						autoHideDuration: 1500,
						variant: 'error',
					}),
				);
			});
		return () => {
			isMounted = false;
		};
	}, [roomPage, filters?.school_id, dispatch]);

	const handleLoadMore = () => {
		setFetchingMore(true);
		getParentsInformation(
			searchQuery,
			filters.room_id === 'All' ? '' : filters.room_id,
			filters.room_id === 'All'
				? filters.school_id
				: filters.room_id
					? rooms.filter((room) => room.id == filters.room_id)[0].school_id
					: filters.school_id === 'All'
						? ''
						: filters.school_id,
			filters.package_type,
			filters.date_from,
			filters.date_to,
			page,
			0,
		)
			.then((res) => {
				if (res.data.last_page > res.data.current_page) {
					setHasMore(true);
				} else {
					setHasMore(false);
				}
				setPage(res.data.current_page + 1);
				setRows(rows.concat(res.data.data));
				setFetchingMore(false);
			})
			.catch((err) => {
				setFetchingMore(false);
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					}),
				);
			});
	};

	const handlemore = (row) => {
		dispatch(
			Actions.openDialog({
				children: (
					<div className="bg-white student-list-card">
						<div className="flex justify-between student-list-header">
							<div>
								<h1>Students</h1>
							</div>
							<div>
								<i
									className="fas text-[20px]"
									onClick={() => dispatch(Actions.closeDialog())}
									style={{ cursor: 'pointer' }}
								/>
							</div>
						</div>
						{roomId ? (
							<div className="student-list-cont w-full" id="scrollable-list">
								{roomId === 'All' ? (
									<>
										{row.parent?.family_child
											?.filter((child) => child.school_id === row.school_id)
											?.slice(2)
											.map((child, i) => (
												<div className="flex items-center " style={{ padding: 14 }} key={i}>
													<Avatar className="mr-6" src={child.thumb} />
													<div className="flex flex-col items-start">
														<div className="student-name  break-word">
															{child.first_name} {child.last_name}
														</div>
													</div>
												</div>
											))}
									</>
								) : (
									<>
										{row.parent?.family_child
											?.filter((child) => child.home_room.id === roomId)
											?.slice(2)
											?.map((child, i) => (
												<div className="flex items-center " style={{ padding: 14 }} key={i}>
													<Avatar className="mr-6" src={child.thumb} />
													<div className="flex flex-col items-start">
														<div className="student-name  break-word">
															{child.first_name} {child.last_name}
														</div>
													</div>
												</div>
											))}
									</>
								)}
							</div>
						) : (
							<div className="student-list-cont w-full" id="scrollable-list">
								{row.parent?.family_child
									?.filter((child) => child.school_id === row.school_id)
									?.slice(2)
									?.map((child, i) => (
										<div className="flex items-center " style={{ padding: 14 }} key={i}>
											<Avatar className="mr-6" src={child.thumb} />
											<div className="flex flex-col items-start">
												<div className="student-name  break-word">
													{child.first_name} {child.last_name}
												</div>
											</div>
										</div>
									))}
							</div>
						)}
					</div>
				),
			}),
		);
	};

	const ApplyFilters = () => {
		setRows([]);
		setIsLoading(true);
		setFirstLoad(false);
		getParentsInformation(
			searchQuery,
			filters.room_id === 'All' ? '' : filters.room_id,
			filters.room_id === 'All'
				? filters.school_id
				: filters.room_id
					? rooms.filter((room) => room.id == filters.room_id)[0].school_id
					: filters.school_id === 'All'
						? ''
						: filters.school_id,
			// filters.school_id === 'All' ? '' : filters.school_id,
			filters.package_type,
			filters.date_from,
			filters.date_to,
			1,
			0,
		)
			.then((res) => {
				setRows(res.data.data);
				if (res.data.last_page > res.data.current_page) {
					setHasMore(true);
				} else {
					setHasMore(false);
				}
				setPage(res.data.current_page + 1);
				setRoomid(filters.room_id);
				dispatch(
					Actions.showMessage({
						message: 'Report has been generated',
						variant: 'success',
					}),
				);
			})
			.catch((err) => {
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					}),
				);
			})
			.finally(() => {
				setIsLoading(false);
			});
		setPage(1);
	};

	const handlePrint = useReactToPrint({
		content: () => checkInReportRef.current,
	});

	const handleExport = () => {
		setIsExporting(true);
		getParentsInformation(
			searchQuery,
			filters.room_id === 'All' ? '' : filters.room_id,
			filters.room_id === 'All'
				? filters.school_id
				: filters.room_id
					? rooms.filter((room) => room.id == filters.room_id)[0].school_id
					: filters.school_id === 'All'
						? ''
						: filters.school_id,
			filters.package_type,
			filters.date_from,
			filters.date_to,
			1,
			1,
		)
			.then((res) => {
				const blob = new Blob([res.data], {
					type: 'text/csv',
				});
				const link = document.createElement('a');
				link.setAttribute('target', '_blank');
				link.href = window.URL.createObjectURL(blob);
				link.setAttribute('download', `parent_subscription_report_${new Date().getTime()}.csv`);
				document.body.appendChild(link);
				link.click();
				// Clean up and remove the link
				link.parentNode.removeChild(link);
			})
			.catch((err) => {
				dispatch(
					Actions.showMessage({
						message: 'Failed to Export',
						variant: 'error',
					}),
				);
			})
			.finally(() => {
				setIsExporting(false);
			});
	};

	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<div className="mx-auto allergy-cont">
				<div className="flex items-center flex-nowrap justify-between">
					<div className="reports-topDiv">
						<h1 className="">
							{' '}
							<span className="">
								<IconButton
									onClick={() => {
										navigate('/company-reports');
									}}
								>
									<img alt="filter" className="" src="assets/images/arrow-long.png" width="24px" />
								</IconButton>
							</span>{' '}
							<span className="text-pd-xl self-end font-bold mr-28">Parent Subscription Report</span>
						</h1>
						<p>Detailed data of parent subscription information </p>
					</div>
					<div className="flex justify-between">
						<div className="flex">
							<div className="self-end btn-aller">
								<span>
									{!isExporting ? (
										<CustomButton
											height="40px"
											marginRight="17px"
											onClick={handleExport}
											variant="primary"
											width="100px"
										>
											<span className="mr-4">
												<FontAwesomeIcon icon={faDownload} />
											</span>
											Export
										</CustomButton>
									) : (
										<div className="circle-bar">
											<CircularProgress size={35} />
										</div>
									)}
									<CustomButton height="40px" onClick={() => handlePrint()} variant="secondary" width="100px">
										<i aria-hidden="true" className="fa fa-print" /> Print
									</CustomButton>
									{/* <div className="help-btn cursor-pointer">
										<img src="assets/images/CENTER.png" />
										Help Center
									</div> */}
								</span>
							</div>
						</div>
					</div>
				</div>

				<div className="flex items-center flex-nowrap justify-between">
					<span className="text-pd-2xl self-end font-extrabold mr-28" />
					<div className="flex justify-between">
						<div className="flex">
							<div className="mx-8">
								<TextField
									InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<IconButton
													id="search-icon"
													onClick={() => {
														document.getElementById('search-input').focus();
													}}
												>
													<img alt="search-icon" height="80%" src="assets/images/search-icon.svg" width="80%" />
												</IconButton>
											</InputAdornment>
										),
									}}
									className="mr-10 width-set-for-small-screen-search"
									id="search-input"
									label="Search by Parent"
									onChange={handleSearch}
									style={{ width: 170 }}
									value={searchQuery}
								/>
							</div>
							<div className="mx-8">
								<FormControl>
									<InputLabel id="schoolLabel">School</InputLabel>
									<Select
										className="width-set-for-small-screen"
										endAdornment={
											filters?.school_id ? (
												<IconButton className="mr-16" size="small">
													<Close
														fontSize="small"
														onClick={() => {
															setFilters({
																...filters,
																school_id: '',
																room_id: '',
															});
															setRooms([]);
															setRoomPage(1);
														}}
													/>
												</IconButton>
											) : (
												''
											)
										}
										label="School"
										labelId="schoolLabel"
										name="school_id"
										onChange={handleFilters}
										style={{ width: 150 }}
										value={filters.school_id}
									>
										<MenuItem value="All">All</MenuItem>
										{schools?.length ? (
											schools?.map((school) => {
												return (
													<MenuItem id={school?.id} key={school?.id} value={school?.id}>
														<div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{school?.name}</div>
													</MenuItem>
												);
											})
										) : (
											<MenuItem disabled>Loading...</MenuItem>
										)}
									</Select>
								</FormControl>
							</div>
							<div className="mx-8">
								<FormControl>
									<InputLabel id="room_id">Room</InputLabel>
									<Select
										className="width-set-for-small-screen"
										endAdornment={
											filters.room_id ? (
												<IconButton className="mr-16" id="clear-room-filter" size="small">
													<Close
														fontSize="small"
														onClick={() => {
															setFilters({
																...filters,
																room_id: '',
															});
														}}
													/>
												</IconButton>
											) : (
												''
											)
										}
										id="room_id"
										label="Room"
										labelId="roomLabel"
										name="room_id"
										onChange={handleFilters}
										style={{ width: 150 }}
										value={filters.room_id}
									>
										<MenuItem value="All">All</MenuItem>
										{rooms.length ? (
											rooms.map((room) => {
												return (
													<MenuItem id={room.id} key={room.id} value={room.id}>
														{room.name}
													</MenuItem>
												);
											})
										) : (
											<MenuItem disabled>Loading...</MenuItem>
										)}
									</Select>
								</FormControl>
							</div>

							<div className="mx-8">
								<FormControl>
									<InputLabel id="package_type">Package Type</InputLabel>
									<Select
										className="width-set-for-small-screen"
										endAdornment={
											filters.package_type ? (
												<IconButton className="mr-16" id="clear-room-filter" size="small">
													<Close
														fontSize="small"
														onClick={() => {
															setFilters({
																...filters,
																package_type: '',
															});
														}}
													/>
												</IconButton>
											) : (
												''
											)
										}
										id="package_type"
										label="Package Type"
										labelId="package_type"
										name="package_type"
										onChange={handleFilters}
										style={{ width: 150 }}
										value={filters.package_type}
									>
										<MenuItem value="1">Included</MenuItem>
										<MenuItem value="2">Premium</MenuItem>
										<MenuItem value="3">Ultimate</MenuItem>
									</Select>
								</FormControl>
							</div>
							<div className="mx-10 student-date-field width-set-for-small-screen" style={{ width: 150 }}>
								<CustomDatePicker
									id="date-from"
									label="Date From"
									maxDate={filters.toDate || new Date()}
									setValue={(date) => {
										setFilters({ ...filters, date_from: date?.format('YYYY-MM-DD') || '' });
									}}
									value={filters.date_from}
								/>
							</div>
							<div className="mr-20 ml-10 student-date-field width-set-for-small-screen" style={{ width: 150 }}>
								<CustomDatePicker
									id="date-to"
									label="Date To"
									maxDate={new Date()}
									minDate={filters.fromDate}
									setValue={(date) => {
										setFilters({ ...filters, date_to: date?.format('YYYY-MM-DD') || '' });
									}}
									value={filters.date_to}
								/>
							</div>
						</div>

						<div className="self-end">
							<span>
								<span className="mx-4">
									<CustomButton
										disabled={
											!filters.package_type &&
											!filters.room_id &&
											!filters.school_id &&
											!filters.date_from &&
											!filters.date_to
												? !searchQuery
												: null
										}
										fontSize="15px"
										height="43"
										onClick={() => {
											ApplyFilters();
										}}
										variant="secondary"
										width="140px"
									>
										Apply
									</CustomButton>
								</span>
							</span>
						</div>
					</div>
				</div>

				{/* table  */}
				<TableContainer className="allergy-table-cont" component={Paper} id="Scrollable-table">
					<div style={{ display: 'none' }}>
						<div className="p-32" ref={checkInReportRef}>
							<div className="flex flex-row justify-between">
								<div>
									<img alt="" src="assets/images/logos/logo.png" />
								</div>
								<div style={{ textAlign: 'right' }}>
									<Typography variant="subtitle1">
										<span style={{ display: 'block', marginBottom: '-0.7em', writingMode: '' }}>
											{user?.data?.school?.address}
										</span>{' '}
										{/* <span>Hom Lake, Orlando, FL 38637</span> */}
									</Typography>
									<Typography variant="subtitle1">{user?.data?.phone}</Typography>
									<Typography variant="subtitle1">{user?.data?.email}</Typography>
								</div>
							</div>
							<div style={{ marginBottom: '20px' }}>
								<span>
									<strong>Date: </strong>
								</span>
								<span>{moment(date).format('dddd, DD MMMM YYYY')}</span>
							</div>
							<div className="pdf-heading">
								<h1 className="font-extrabold">Parent Subscription Report</h1>
							</div>

							<Table className="student-table" stickyHeader style={{ width: '100%' }}>
								<TableHead>
									<TableRow>
										<TableCell className="bg-white studentTableHeader" style={{ width: '20%' }}>
											Parent
										</TableCell>
										<TableCell className="bg-white studentTableHeader" style={{ width: '30%' }}>
											Students
										</TableCell>
										<TableCell className="bg-white studentTableHeader" style={{ width: '30%' }}>
											School Name
										</TableCell>
										<TableCell className="bg-white studentTableHeader" style={{ width: '4%' }}>
											Package Type
										</TableCell>
										<TableCell className="bg-white studentTableHeader" style={{ width: '4%' }}>
											Amount
										</TableCell>
										<TableCell className="bg-white studentTableHeader" style={{ width: '7%' }}>
											Date
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody className="">
									{firstLoad ? (
										<TableRow>
											<TableCell align="center" colSpan={8}>
												Generate your report
											</TableCell>
										</TableRow>
									) : isLoading ? (
										<TableRow>
											<TableCell align="center" colSpan={8}>
												<CircularProgress size={35} />
											</TableCell>
										</TableRow>
									) : !rows.length && !isLoading ? (
										<TableRow>
											<TableCell align="center" colSpan={8}>
												No record found
											</TableCell>
										</TableRow>
									) : (
										rows?.map((row) => (
											<TableRow key={row.id} className="mb-12">
												<TableCell style={{ fontWeight: 700 }} component="th" scope="row">
													<div id={`student-${row.id}`} className="flex">
														<Avatar className="mr-6" src={row?.parent?.thumb} />
														<div className="flex items-center">
															<div className="student-name  break-word">
																{row?.parent?.first_name} {row?.parent?.last_name}
															</div>
														</div>
													</div>
												</TableCell>
												{roomId ? (
													<TableCell align="left">
														{roomId === 'All' ? (
															<div className="flex items-center justify-between">
																<div className="flex flex-col items-center">
																	{row.parent?.family_child.filter((child) => child.school_id === row.school_id)
																		.length > 2
																		? row.parent?.family_child
																				.filter((child) => child.school_id === row.school_id)
																				.map((child, i) => {
																					return (
																						<div
																							className="flex items-center parent-column"
																							key={i}
																							style={{ marginRight: 20 }}
																						>
																							<Avatar className="mr-6" src={child.thumb} />
																							<div className="flex flex-col items-start">
																								<div
																									className="student-name  break-word "
																									style={{
																										width: '90px',
																										color: '#6387d4',
																										fontSize: '12px',
																										fontWeight: '700',
																									}}
																								>
																									{child?.home_room?.name}
																								</div>
																								<div
																									className="student-name  break-word"
																									style={{
																										width: '90px',
																									}}
																								>
																									{child.first_name} {child.last_name}
																								</div>
																								<div
																									className="font-normal student-age-font"
																									style={{
																										width: '90px',
																									}}
																								>
																									{generateAgeString(child.date_of_birth)}
																								</div>
																							</div>
																						</div>
																					);
																				})
																		: row.parent?.family_child
																				.filter((child) => child.school_id === row.school_id)
																				.map((child, i) => {
																					return (
																						<div
																							className="flex items-center parent-column"
																							key={i}
																							style={{ marginRight: 20 }}
																						>
																							<Avatar className="mr-6" src={child.thumb} />
																							<div className="flex flex-col items-start">
																								<div
																									className="student-name  break-word "
																									style={{
																										width: '90px',
																										color: '#6387d4',
																									}}
																								>
																									{child?.home_room?.name}
																								</div>
																								<div
																									className="student-name  break-word "
																									style={{
																										width: '90px',
																									}}
																								>
																									{child.first_name} {child.last_name}
																								</div>
																								<div
																									className="font-normal student-age-font"
																									style={{
																										width: '90px',
																									}}
																								>
																									{generateAgeString(child.date_of_birth)}
																								</div>
																							</div>
																						</div>
																					);
																				})}
																</div>
																<div />
															</div>
														) : (
															<div className="flex items-center justify-between">
																<div className="flex flex-col items-center">
																	{row.parent?.family_child.filter((child) => child.home_room.id === roomId).length > 2
																		? row.parent?.family_child
																				.filter((child) => child.home_room.id === roomId)
																				?.map((child, i) => {
																					return (
																						<div
																							className="flex items-center parent-column"
																							key={i}
																							style={{ marginRight: 20 }}
																						>
																							<Avatar className="mr-6" src={child.thumb} />
																							<div className="flex flex-col items-start">
																								<div
																									className="student-name  break-word "
																									style={{
																										width: '90px',
																										color: '#6387d4',
																										fontSize: '12px',
																										fontWeight: '700',
																									}}
																								>
																									{child?.home_room?.name}
																								</div>
																								<div
																									className="student-name  break-word"
																									style={{
																										width: '90px',
																									}}
																								>
																									{child.first_name} {child.last_name}
																								</div>
																								<div
																									className="font-normal student-age-font"
																									style={{
																										width: '90px',
																									}}
																								>
																									{generateAgeString(child.date_of_birth)}
																								</div>
																							</div>
																						</div>
																					);
																				})
																		: row.parent?.family_child
																				.filter((child) => child.home_room.id === roomId)
																				?.map((child, i) => {
																					return (
																						<div
																							className="flex items-center parent-column"
																							key={i}
																							style={{ marginRight: 20 }}
																						>
																							<Avatar className="mr-6" src={child.thumb} />
																							<div className="flex flex-col items-start">
																								<div
																									className="student-name  break-word "
																									style={{
																										width: '90px',
																										color: '#6387d4',
																									}}
																								>
																									{child?.home_room?.name}
																								</div>
																								<div
																									className="student-name  break-word "
																									style={{
																										width: '90px',
																									}}
																								>
																									{child.first_name} {child.last_name}
																								</div>
																								<div
																									className="font-normal student-age-font"
																									style={{
																										width: '90px',
																									}}
																								>
																									{generateAgeString(child.date_of_birth)}
																								</div>
																							</div>
																						</div>
																					);
																				})}
																</div>
																<div />
															</div>
														)}
													</TableCell>
												) : (
													<TableCell align="left">
														<div className="flex items-center justify-between">
															<div className="flex flex-col items-center">
																{row.parent?.family_child.filter((child) => child.school_id === row.school_id).length >
																2
																	? row.parent?.family_child
																			.filter((child) => child.school_id === row.school_id)
																			?.map((child, i) => {
																				return (
																					<div
																						className="flex items-center parent-column"
																						key={i}
																						style={{ marginRight: 20 }}
																					>
																						<Avatar className="mr-6" src={child.thumb} />
																						<div className="flex flex-col items-start">
																							<div
																								className="student-name  break-word "
																								style={{
																									width: '90px',
																									color: '#6387d4',
																									fontSize: '12px',
																									fontWeight: '700',
																								}}
																							>
																								{child?.home_room?.name}
																							</div>
																							<div
																								className="student-name  break-word"
																								style={{
																									width: '90px',
																								}}
																							>
																								{child.first_name} {child.last_name}
																							</div>
																							<div
																								className="font-normal student-age-font"
																								style={{
																									width: '90px',
																								}}
																							>
																								{generateAgeString(child.date_of_birth)}
																							</div>
																						</div>
																					</div>
																				);
																			})
																	: row.parent?.family_child
																			.filter((child) => child.school_id === row.school_id)
																			?.map((child, i) => {
																				return (
																					<div
																						className="flex items-center parent-column"
																						key={i}
																						style={{ marginRight: 20 }}
																					>
																						<Avatar className="mr-6" src={child.thumb} />
																						<div className="flex flex-col items-start">
																							<div
																								className="student-name  break-word "
																								style={{
																									width: '90px',
																									color: '#6387d4',
																								}}
																							>
																								{child?.home_room?.name}
																							</div>
																							<div
																								className="student-name  break-word "
																								style={{
																									width: '90px',
																								}}
																							>
																								{child.first_name} {child.last_name}
																							</div>
																							<div
																								className="font-normal student-age-font"
																								style={{
																									width: '90px',
																								}}
																							>
																								{generateAgeString(child.date_of_birth)}
																							</div>
																						</div>
																					</div>
																				);
																			})}
															</div>
															<div />
														</div>
													</TableCell>
												)}
												<TableCell>
													<div className="break-word" style={{ fontSize: '12px', fontWeight: '700' }}>
														{row?.school?.name}
													</div>
												</TableCell>
												<TableCell align="left">
													<div style={{ fontSize: '12px', fontWeight: '700' }}>
														{row?.package?.title.split('Subscription')}
													</div>
												</TableCell>
												<TableCell align="left">
													<div style={{ fontSize: 12, fontWeight: '700' }}>${row.package_price}</div>
												</TableCell>

												<TableCell>
													<div className="flex flex-col">
														<div
															style={{
																fontSize: '12px',
																fontWeight: '700',
																color: '#000',
															}}
														>
															{moment.utc(row?.created_at).local().format('L')}
														</div>
														<div className="subscribe-date" style={{ fontSize: '10px' }}>
															{moment.utc(row?.created_at).local().format('LT')}
														</div>
													</div>
												</TableCell>
											</TableRow>
										))
									)}
									{/* {fetchingMore ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										<CircularProgress />
									</TableCell>
								</TableRow>
							) : (
								<></>
							)} */}
								</TableBody>
							</Table>
						</div>
					</div>
					<Table className="student-table" stickyHeader style={{ width: '100%' }}>
						<TableHead>
							<TableRow>
								<TableCell className="bg-white studentTableHeader" style={{ width: '15%' }}>
									Parent
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '25%' }}>
									Students
								</TableCell>
								<TableCell className="bg-white userTableHeader" style={{ width: '15%', padding: 0 }} />
								<TableCell className="bg-white studentTableHeader" style={{ width: '15%' }}>
									School Name
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '15%' }}>
									Package Type
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '10%' }}>
									Amount
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '10%' }}>
									Date
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody className="">
							{firstLoad ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										Generate your report
									</TableCell>
								</TableRow>
							) : isLoading ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										<CircularProgress size={35} />
									</TableCell>
								</TableRow>
							) : !rows.length && !isLoading ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										No record found
									</TableCell>
								</TableRow>
							) : (
								rows?.map((row) => (
									<TableRow key={row.id}>
										<TableCell style={{ fontWeight: 700 }} component="th" scope="row">
											<div id={`student-${row.id}`} className="flex">
												<Avatar className="mr-6" src={row?.parent?.thumb} />
												<div className="flex items-center">
													<div className="student-name  break-word">
														{row?.parent?.first_name} {row?.parent?.last_name}
													</div>
												</div>
											</div>
										</TableCell>

										{roomId ? (
											<>
												<TableCell style={{ fontWeight: 700 }}>
													<div className="flex items-center justify-between">
														{roomId === 'All' ? (
															<>
																{row?.parent?.family_child
																	.filter((child) => child.school_id === row.school_id)
																	?.map((child, i) => {
																		return (
																			<div
																				className="flex items-center parent-column"
																				key={i}
																				style={{ marginRight: 20 }}
																			>
																				<Avatar className="mr-6" src={child.thumb} />
																				<div className="flex flex-col items-start">
																					<div
																						className="student-name  break-word "
																						style={{
																							width: '90px',
																							color: '#6387d4',
																							fontSize: '12px',
																							fontWeight: '700',
																						}}
																					>
																						{child?.home_room?.name}
																					</div>
																					<div className="student-name  break-word" style={{ width: '90px' }}>
																						{child.first_name} {child.last_name}
																					</div>
																					<div className="font-normal  student-age-font" style={{ fontSize: 10 }}>
																						<div className="font-normal student-age-font" style={{ width: '90px' }}>
																							{generateAgeString(child.date_of_birth)}
																						</div>
																					</div>
																				</div>
																			</div>
																		);
																	})
																	.splice(0, 2)}
															</>
														) : (
															<>
																{row?.parent?.family_child
																	.filter((child) => child.home_room.id === roomId)
																	?.map((child, i) => {
																		return (
																			<div
																				className="flex items-center parent-column"
																				key={i}
																				style={{ marginRight: 20 }}
																			>
																				<Avatar className="mr-6" src={child.thumb} />
																				<div className="flex flex-col items-start">
																					<div
																						className="student-name  break-word "
																						style={{
																							width: '90px',
																							color: '#6387d4',
																						}}
																					>
																						{child?.home_room?.name}
																					</div>
																					<div className="student-name  break-word" style={{ width: '90px' }}>
																						{child.first_name} {child.last_name}
																					</div>
																					<div className="font-normal student-age-font" style={{ width: '90px' }}>
																						{generateAgeString(child.date_of_birth)}
																					</div>
																				</div>
																			</div>
																		);
																	})
																	.splice(0, 2)}
															</>
														)}
													</div>
												</TableCell>
												<TableCell style={{ paddingLeft: '64px' }}>
													<div>
														{roomId === 'All' ? (
															<>
																{row.parent?.family_child.filter((child) => child.school_id === row.school_id).length >
																2 ? (
																	<h5 className="child-num cursor-pointer" onClick={() => handlemore(row)}>
																		&nbsp; +
																		{row.parent?.family_child.filter((child) => child.school_id === row.school_id)
																			.length > 2
																			? `${
																					row.parent?.family_child.filter((child) => child.school_id === row.school_id)
																						.length - 2
																				} Others`
																			: null}{' '}
																	</h5>
																) : (
																	<></>
																)}
															</>
														) : (
															<>
																{row?.parent?.family_child.filter((child) => child.home_room.id === roomId)?.length >
																2 ? (
																	<div
																		onClick={() => handlemore(row)}
																		style={{
																			cursor: 'pointer',
																			fontSize: '11px',
																			color: '#008dff',
																			fontWeight: 700,
																			marginLeft: -12,
																		}}
																	>
																		{' '}
																		+
																		{`${
																			row?.parent?.family_child.filter((child) => child.home_room.id === roomId)
																				?.length - 2
																		} Others`}
																	</div>
																) : (
																	''
																)}
															</>
														)}
													</div>
												</TableCell>
											</>
										) : (
											<>
												<TableCell style={{ fontWeight: 700 }}>
													<div className="flex items-center justify-between">
														{row?.parent?.family_child
															.filter((child) => child.school_id === row.school_id)
															?.map((child, i) => {
																return (
																	<div className="flex items-center parent-column" key={i} style={{ marginRight: 20 }}>
																		<Avatar className="mr-6" src={child.thumb} />
																		<div className="flex flex-col items-start">
																			<div
																				className="student-name  break-word "
																				style={{
																					width: '90px',
																					color: '#6387d4',
																					fontSize: '12px',
																					fontWeight: '700',
																				}}
																			>
																				{child?.home_room?.name}
																			</div>
																			<div className="student-name  break-word" style={{ width: '90px' }}>
																				{child.first_name} {child.last_name}
																			</div>
																			<div className="font-normal student-age-font" style={{ width: '90px' }}>
																				{generateAgeString(child.date_of_birth)}
																			</div>
																		</div>
																	</div>
																);
															})
															.splice(0, 2)}
													</div>
												</TableCell>
												<TableCell style={{ paddingLeft: '64px' }}>
													{row.parent?.family_child.filter((child) => child.school_id === row.school_id).length > 2 ? (
														<h5 className="child-num cursor-pointer" onClick={() => handlemore(row)}>
															&nbsp; +
															{row.parent?.family_child.filter((child) => child.school_id === row.school_id).length > 2
																? `${
																		row.parent?.family_child.filter((child) => child.school_id === row.school_id)
																			.length - 2
																	} Others`
																: null}{' '}
														</h5>
													) : (
														<></>
													)}
												</TableCell>
											</>
										)}
										<TableCell>
											<div className="break-word" style={{ fontSize: '12px', fontWeight: '700' }}>
												{row?.school?.name}
											</div>
										</TableCell>
										<TableCell align="left">
											<div style={{ fontSize: '12px', fontWeight: '700' }}>
												{row?.package?.title.split('Subscription')}
											</div>
										</TableCell>
										<TableCell align="left">
											<div style={{ fontSize: 12, fontWeight: '700' }}>${row.package_price}</div>
										</TableCell>
										<TableCell>
											<div className="flex flex-col">
												<div style={{ fontSize: '12px', fontWeight: '700', color: '#000' }}>
													{moment.utc(row?.created_at).local().format('L')}
												</div>
												<div className="subscribe-date" style={{ fontSize: '10px' }}>
													{moment.utc(row?.created_at).local().format('LT')}
												</div>
											</div>
										</TableCell>
									</TableRow>
								))
							)}
							{fetchingMore ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										<CircularProgress />
									</TableCell>
								</TableRow>
							) : (
								<></>
							)}
						</TableBody>
					</Table>
				</TableContainer>
				<InfiniteScroll
					dataLength={rows?.length}
					hasMore={hasMore}
					next={handleLoadMore}
					scrollableTarget="Scrollable-table"
				/>
			</div>
		</FuseAnimate>
	);
}
